import { Inject, Injectable } from '@angular/core';
import {
  NgEntityService,
  NgEntityServiceConfig
} from '@datorama/akita-ng-entity-service';
import { tap } from 'rxjs/operators';
import * as io from 'socket.io-client';
import { SDKConfig } from '../config/sdk-config.interface';
import { SDK_CONFIG_TOKEN } from '../config/sdk.config.token';
import { GroupService } from '../group';
import { RequestService, RequestStatus } from '../request';
import {
  Notification,
  NotificationStatus,
  NotificationType
} from './notification.model';
import { NotificationState, NotificationStore } from './notification.store';

@NgEntityServiceConfig({
  resourceName: 'notifications',
})
@Injectable()
export class NotificationService extends NgEntityService<NotificationState> {
  socket!: any;

  constructor(
    protected store: NotificationStore,
    private requestService: RequestService,
    private groupService: GroupService,
    @Inject(SDK_CONFIG_TOKEN) private sdkConfig: SDKConfig
  ) {
    super(store);
  }

  get1(status = 'new', store = true) {
    return this.getHttp()
      .get<Notification[]>(`${this.sdkConfig.gatewayUrl}/notifications`, { params: { status } })
      .pipe(
        tap((notifications) => {
          if (store) {
            this.store.set(notifications);
          }
        })
      );
  }

  init(token: string) {
    this.get1().subscribe();
    this.socket = io(this.sdkConfig.notificationsUrl, {
      transports: ['websocket'],
    });
    this.connect(token);
  }

  connect(token: string) {
    this.socket.on('connect', () => {
      this.socket.emit('authenticate', { token });
      this.socket.on('authenticated', () => {
        this.socket.emit('@notification/subscribe');

        // Call this.get() so we can populated object from backend
        this.socket.on('newNotification', ({ id }: Notification) =>
          this.get<Notification>(id)
            .pipe(
              tap((notification) => this.handleNewNotification(notification))
            )
            .subscribe()
        );
      });
    });
  }

  handleNewNotification(notification: Notification) {
    switch (notification.type) {
      case NotificationType.JoinGroupRequestReceived: {
        const { requestId } = notification.data as { requestId: string };
        this.requestService.get(requestId).subscribe();
        break;
      }
      case NotificationType.JoinGroupRequestAccepted: {
        const { requestId } = notification.data as { requestId: string };
        this.requestService.setStatus(requestId, RequestStatus.Accepted);
        this.groupService.updateGroup(notification.relatedDocumentId, notification.relatedDocument)
        break;
      }
      case NotificationType.JoinGroupRequestRejected: {
        const { requestId } = notification.data as { requestId: string };
        this.requestService.setStatus(requestId, RequestStatus.Rejected);
        break;
      }
      case NotificationType.RemovedFromGroup: {
        this.groupService.removedFromGroupHandler(notification);
        break;
      }
      case NotificationType.PlayerJoinedGroup: {
        this.groupService.playerJoinedGroupHandler(notification);
        break;
      }
      default:
        break;
    }
  }

  markAsRead(ids: string[]) {
    this.socket.emit('@notification/updateStatus', {
      ids,
      status: NotificationStatus.Read,
    });
    this.store.update(ids, () => ({ status: NotificationStatus.Read }));
  }
}
